<template>
    <base-button
        :class="[
            'gap-2',
            'focus:outline-none focus:ring-1 focus:ring-black focus:border-black ring-offset-2',
        ]"
        :tooltip-text="tooltipText"
    >
        <!-- Library build does not like dynamic URLs -->
        <img
            v-if="iconName === 'help'"
            src="../../assets/images/icons/help.svg"
            :alt="iconName"
            height="22"
            width="22"
        >

        <img v-if="iconName === 'undo'"
            src="../../assets/images/icons/undo.svg"
            :alt="iconName"
            height="22"
            width="22"
        >

        <img v-if="iconName === 'share'"
            src="../../assets/images/icons/share.svg"
            :alt="iconName"
            height="22"
            width="22"
        >

        <img v-if="iconName === 'info'"
            src="../../assets/images/icons/info.svg"
            :alt="iconName"
            height="22"
            width="22"
        >
        <span class="text-base font-semibold">
            {{ buttonText }}
        </span>
    </base-button>
</template>

<script>
    import BaseButton from './BaseButton.vue';

    export default {
        components: {
            BaseButton,
        },

        props: {
            iconName: {
                type: String,
                required: true,
            },
            buttonText: {
                type: String,
                default: '',
            },
            tooltipText: {
                type: String,
                default: null,
            },
        },
    };
</script>
